<div class="panel-container">
  <div class="panel-backdrop" (click)="onClose()"></div>
  <div class="panel side-panel" [class.side-panel--opened]="opened">
    <mat-icon class="side-panel__close-button" aria-label="edit-profile" (click)="onClose()" svgIcon="close"></mat-icon>
    <div class="side-panel__content">
      <ng-container [cdkPortalHost]="contentPortal"></ng-container>
    </div>
  </div>
</div>
